import React, { Component } from "react";
import Modal from 'react-responsive-modal';
import { Link } from 'react-router-dom';
import DeleteConfirmModal from '../common/deleteConfirmModal';
import Popover from 'react-simple-popover';

class PageActions extends Component {

    constructor() {
        super();
        this.state = {                  
            IsDeleteConfirmModalOpen: false,
            open: false
        }
    }    

    handleClick(e) {
        this.setState({ open: !this.state.open });
    }

    handleClose(e) {
        this.setState({ open: false });
    }

    openDeleteConfirmModal = () => {        
        this.setState({ IsDeleteConfirmModalOpen: true });
    };

    closeDeleteConfirmModal = () => {
        this.setState({ IsDeleteConfirmModalOpen: false });
    };    

    render() {        

        return (
            <div>
                <button type="button" className="btn btn-default" ref="useraction" onClick={this.handleClick.bind(this)}>
                    <i className="la la-ellipsis-h"></i>
                </button>
                <Popover
                    placement='bottom'
                    target={this.refs.useraction}
                    show={this.state.open}
                    style={{ padding: '0px' }}
                    containerStyle={{ marginLeft: '20px', zIndex: 999 }}
                    onHide={this.handleClose.bind(this)} >
                    <Link to={{ pathname: '/pages/edit', state: { action: 'edit', id: this.props.Id, item: this.props.item } }} className="page-action edit-action">
                        <i className="la la-pencil"></i> Edit
                            </Link>  
                    <button className="delete-action" onClick={this.openDeleteConfirmModal}>
                        <i className="la la-trash-o"></i> Delete
                            </button>
                </Popover>
                {/*
                  <div className="dropdown">
                    <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i className="la la-ellipsis-h"></i>
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                        <li>
                            <Link to={{ pathname: '/pages/edit', state: { action: 'edit', id: this.props.Id, item: this.props.item } }} className="page-action edit-action">
                                <i className="la la-pencil"></i> Edit
                            </Link>
                        </li>
                        <li>
                            <button className="delete-action" onClick={this.openDeleteConfirmModal}>
                                <i className="la la-trash-o"></i> Delete
                            </button>
                        </li>
                    </ul>
                </div>
                 */}
               
                
                <Modal open={this.state.IsDeleteConfirmModalOpen} center showCloseIcon={false} onClose={this.closeDeleteConfirmModal}>
                    <DeleteConfirmModal closeDeleteConfirmModal={this.closeDeleteConfirmModal}
                        title="Delete Page"
                        message="Are you sure you want to delete this page?"
                        Id={this.props.Id}
                        action={this.props.action}
                        orderby={this.props.orderby}
                        sortby={this.props.sortby}
                        search={this.props.search} page={this.props.page}
                        removeItems={this.props.removeItems} />
                </Modal>
            </div>
        );
    }
}

export default PageActions;